import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';

import EntityTable from "../Listing/EntityTable";
import Accordion from "../NavTab/Accordion";
import NewInvoiceModal from "../Modal/NewInvoiceModal";
import CreateReturnModal from "../Modal/CreateReturnModal";

import useOrderColumns from "../../hooks/orderColumns";
import { StatusBadge, formatAmount } from "../Order/orderColumns";
import { formatRelativeDate } from "../../utils/FormatDate";
import { NavLink } from "react-router-dom";
import { API_BASE_URL } from '../../api';

const PatientOrders = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showNewInvoiceModal, setShowNewInvoiceModal] = useState(false);
  const [showCreateReturnModal, setShowCreateReturnModal] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const columns = useOrderColumns({
    onNewInvoice: (row) => {
      setSelectedOrder(row);
      setShowNewInvoiceModal(true);
    },
    onCreateReturn: (row) => {
      setSelectedOrder(row);
      setShowCreateReturnModal(true);
    },
    onReload: () => {
      setReloadKey((prev) => prev + 1);
    },
    excludeColumns: ['patientId']
  });

  // Card-view design for this listing (Table's enableCardView feature, forced on mobile)
  // — reuses the actions column's own dropdown so both views offer identical actions.
  const ordersActionsColumn = columns.find((c) => c.accessor === 'actions');
  const renderOrderCard = (row) => (
    <div className="card h-100 shadow-sm">
      <div className="card-body d-flex flex-column" style={{ padding: 14, gap: 6 }}>
        <div style={{ alignSelf: 'flex-start' }}><StatusBadge status={row.status} /></div>

        <NavLink to={`/order/${row.id}`} style={{ fontSize: 13.5, fontWeight: 600, color: '#111827', marginTop: 4 }}>
          {row.reference}
        </NavLink>
        <span style={{ fontSize: 11.5, color: '#9ca3af' }}>{formatRelativeDate(row.createdAt)}</span>

        <div className="d-flex align-items-center justify-content-between" style={{ marginTop: 'auto', paddingTop: 6 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
            <span style={{ fontSize: 15, fontWeight: 700, color: '#111827' }}>{formatAmount(row.total)}</span>
            <span style={{ fontSize: 10.5, color: '#9ca3af', fontWeight: 500 }}>dhs</span>
            <span style={{
              marginLeft: 6, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              width: 22, height: 22, borderRadius: '50%',
              background: '#f3f4f6', fontSize: 11, fontWeight: 700, color: '#374151',
            }}>
              {row.items?.length ?? 0}
            </span>
          </div>
          {ordersActionsColumn?.Cell(row)}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Accordion
        id="patientOrders"
        parent="patient_information_container"
        title={t('Orders')}
        icon={faFileInvoice}
        flush
      >
        <EntityTable
          key={reloadKey}
          endpoint={`${API_BASE_URL}/api/v1/getOrders`}
          columns={columns}
          extraParams={{
            patientId: id
          }}
          pageSize={10}
          emptyMessage="Aucune vente"
          searchable={true}
          multiSelect={false}
          enableCardView={true}
          renderCard={renderOrderCard}
        />
      </Accordion>

      <NewInvoiceModal
        order={selectedOrder}
        show={showNewInvoiceModal}
        onClose={() => setShowNewInvoiceModal(false)}
      />

      <CreateReturnModal
        order={selectedOrder}
        show={showCreateReturnModal}
        onClose={() => { setShowCreateReturnModal(false); setSelectedOrder(null); }}
        onSave={() => setReloadKey((prev) => prev + 1)}
      />
    </>
  );
};

export default PatientOrders;